import type {EditableGraph, ConversationNode} from 'src/types/chatbot';

import * as React from 'react';

import makeClassNameComponent, {
  type ClassNameComponent,
} from 'src/utils/makeClassNameComponent';
import {getFirstMessages} from 'src/components/conversation-builder/utils';

import {OptOutMessage} from 'src/components/conversation-builder/common';
import {useSmsContext} from 'src/components/conversation-builder/sms-context';

import css from 'src/components/conversation-builder/popover.css';

// @ts-expect-error - TS2322 - Type 'AbstractComponent<ComponentProps<C>, unknown>' is not assignable to type 'ClassNameComponent'.
export const PadSection: ClassNameComponent = makeClassNameComponent(
  css.padSection,
);

// @ts-expect-error - TS2322 - Type 'AbstractComponent<ComponentProps<C>, unknown>' is not assignable to type 'ClassNameComponent'.
export const Subsection: ClassNameComponent = makeClassNameComponent(
  css.subsection,
);

export function useFirstSmsMessage(
  graph: EditableGraph,
  node: ConversationNode,
): boolean {
  const isSms = useSmsContext();

  return isSms && getFirstMessages(graph).some(({id}) => node.id === id);
}

export function OptOutSuffix({
  graph,
  node,
}: {
  graph: EditableGraph;
  node: ConversationNode;
}) {
  const isSms = useSmsContext();

  if (isSms) {
    const firstMessages = getFirstMessages(graph);
    return firstMessages.some(({id}) => node.id === id) && <OptOutMessage />;
  }

  return null;
}

// @ts-expect-error - TS2322 - Type 'AbstractComponent<ComponentProps<C>, unknown>' is not assignable to type 'ClassNameComponent'.
export const Table: ClassNameComponent = makeClassNameComponent(css.table);
// @ts-expect-error - TS2322 - Type 'AbstractComponent<ComponentProps<C>, unknown>' is not assignable to type 'ClassNameComponent'.
export const TableHeader: ClassNameComponent = makeClassNameComponent(
  css.tableHeader,
);
// @ts-expect-error - TS2322 - Type 'AbstractComponent<ComponentProps<C>, unknown>' is not assignable to type 'ClassNameComponent'.
export const TableTitle: ClassNameComponent = makeClassNameComponent(
  css.tableTitle,
);
// @ts-expect-error - TS2322 - Type 'AbstractComponent<ComponentProps<C>, unknown>' is not assignable to type 'ClassNameComponent'.
export const ColumnGrow: ClassNameComponent = makeClassNameComponent(
  css.columnGrow,
);
// @ts-expect-error - TS2322 - Type 'AbstractComponent<ComponentProps<C>, unknown>' is not assignable to type 'ClassNameComponent'.
export const ColumnValue: ClassNameComponent = makeClassNameComponent(
  css.columnValue,
);
// @ts-expect-error - TS2322 - Type 'AbstractComponent<ComponentProps<C>, unknown>' is not assignable to type 'ClassNameComponent'.
export const ColumnEnabled: ClassNameComponent = makeClassNameComponent(
  css.columnEnabled,
);
// @ts-expect-error - TS2322 - Type 'AbstractComponent<ComponentProps<C>, unknown>' is not assignable to type 'ClassNameComponent'.
export const TableBody: ClassNameComponent = makeClassNameComponent(
  css.tableBody,
);
// @ts-expect-error - TS2322 - Type 'AbstractComponent<ComponentProps<C>, unknown>' is not assignable to type 'ClassNameComponent'.
export const TableRow: ClassNameComponent = makeClassNameComponent(
  css.tableRowButton,
);
// @ts-expect-error - TS2322 - Type 'AbstractComponent<ComponentProps<C>, unknown>' is not assignable to type 'ClassNameComponent'.
export const TableRowPadded: ClassNameComponent = makeClassNameComponent(
  css.tableRowPadded,
);
// @ts-expect-error - TS2322 - Type 'AbstractComponent<ComponentProps<C>, unknown>' is not assignable to type 'ClassNameComponent'.
export const TableFooter: ClassNameComponent = makeClassNameComponent(
  css.tableFooter,
);
